import { FormKitSchemaFormKit } from "@formkit/core";
import { getCreateForm, getUpdateForm } from "@q-food/q-food";
import { isArray } from "lodash";

/**
 * For a given form name and resourceId, returns the form schema and the original form values within the schema.
 */
function useFormSchema<T>(formName: string, resourceId?: string) {
	const formArrayDefinition = ref<FormKitSchemaFormKit[]>([]);

	if (resourceId) {
		getUpdateForm(formName, resourceId).then((form) => {
			formArrayDefinition.value = form as FormKitSchemaFormKit[];
		});
	} else {
		getCreateForm(formName).then((form) => {
			formArrayDefinition.value = form as FormKitSchemaFormKit[];
		});
	}

	const formObjectDefinition = computed(() => {
		const object: { [key in keyof T]: FormKitSchemaFormKit } = {} as any;
		formArrayDefinition.value.forEach((node) => {
			if (node.$formkit && node.name) {
				object[node.name as keyof T] = node;
			}
		});
		return object;
	});

	const originalFormValues = computed(() => {
		const values: Partial<T> = {};
		formArrayDefinition.value.forEach((node) => {
			if (node.$formkit && node.name && node.value != null) {
				if (typeof node.value == "object" && !isArray(node.value)) {
					// @ts-ignore-next-line
					values[node.name] = Object.fromEntries(Object.entries(node.value).filter(([_, v]) => v != null));
				} else {
					// @ts-ignore-next-line
					values[node.name] = node.value;
				}
			}
		});
		return values as T;
	});

	return {
		originalFormValues,
		formArrayDefinition,
		formObjectDefinition,
	};
}

export { useFormSchema };
